var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.groups),function(group,groupIndex){return _c('div',{key:groupIndex},_vm._l((group.panels),function(panel){return _c(panel.panelName,_vm._b({key:panel.id,tag:"component"},'component',{ data: panel },false))}),1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }